module.exports = {
	"id": "/enet_event_incident",
	"type": "object",
	"properties": {
		"eventId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"sportId": {
			"type": "integer",
			"required": true
		},
		"homeId": {
			"type": "integer",
			"required": true
		},
		"awayId": {
			"type": "integer",
			"required": true
		},
		"incidentId": {
			"type": "integer",
			"required": true
		},
		"debug": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"created": {
					"type": "date-time"
				},
				"eventVersion": {
					"type": "integer"
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/enet_event_incident.json
 ** module id = 1825
 ** module chunks = 0
 **/